// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api';
import type {
  IDeleteSubscriptionRequest,
  TDeleteSubscriptionModel,
  IMappers,
  TDeleteSubscriptionResponse,
  IDeleteSubscriptionResponse,
  IDeleteSubscriptionResponseError,
} from './types';

export const defaultConfig: TDeleteSubscriptionModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  hostType: 'api',
  method: 'POST',
  microserviceName: 'subscriptions',
  pathApi: '/v1/delete-subscription/',
  requestType: 'json',
  responseType: 'json',
} as TDeleteSubscriptionModel;

export function createDeleteSubscriptionModel(parameters: IDeleteSubscriptionRequest): TDeleteSubscriptionModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IDeleteSubscriptionOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: IDeleteSubscriptionRequest;
}

export async function fetchDeleteSubscription<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IDeleteSubscriptionOptions<TResponse200, TResponse400>): Promise<
  TDeleteSubscriptionResponse | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = await httpApi.fetch(createDeleteSubscriptionModel(parameters), config);
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IDeleteSubscriptionResponse);
    }
    if (statusCode === 400) {
      return mappers[400](response as IDeleteSubscriptionResponseError);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as TDeleteSubscriptionResponse;
}
